<template>
  <va-create-layout>
    <stat-question_options-form
      :title="title"
      :item="item"
    ></stat-question_options-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
